import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedWebsites from './components/FeaturedWebsites';
import StatsSection from './components/StatsSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedWebsites />
        <StatsSection />
        <ArticleSection />
        <FAQSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "正品蓝导航",
            "url": "https://www.zhengpinlan.com",
            "description": "专业权威的网址导航平台，汇聚海量正品网站资源，精准分类、安全可信",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://www.zhengpinlan.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "正品蓝导航是什么？", "acceptedAnswer": { "@type": "Answer", "text": "正品蓝导航是一个专业权威的网址导航平台，汇聚海量正品网站资源，经过严格人工审核，为用户提供安全、可靠的上网入口。" } },
              { "@type": "Question", "name": "如何确保收录网站是正品？", "acceptedAnswer": { "@type": "Answer", "text": "我们对每一个收录网站都进行严格的人工审核，包括域名所有权验证、网站资质审核、用户口碑评价和安全扫描检测等多重审核机制。" } },
              { "@type": "Question", "name": "正品蓝导航是否收费？", "acceptedAnswer": { "@type": "Answer", "text": "正品蓝导航完全免费使用。我们坚持为用户提供纯净、无广告的上网导航体验。" } },
              { "@type": "Question", "name": "如何申请收录我的网站？", "acceptedAnswer": { "@type": "Answer", "text": "您可以通过「关于我们」页面的联系方式与我们取得联系。我们的编辑团队会按照标准流程对您的网站进行审核。" } },
              { "@type": "Question", "name": "遇到假冒网站如何举报？", "acceptedAnswer": { "@type": "Answer", "text": "如您发现疑似假冒网站，可以通过「关于我们」页面的联系方式进行举报。我们会在24小时内进行核实处理。" } },
            ]
          })
        }}
      />
    </>
  );
}